import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=8c5ea834"
import script from "./Advert.vue?vue&type=script&lang=js"
export * from "./Advert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports